export const commafy = (val: string | number) => {
	if (typeof val === "string" && !isNaN(Number(val))) {
		return Number(val).toLocaleString("en-US");
	} else if (typeof val === "number") {
		return val.toLocaleString("en-US");
	} else return null;
};
